import { userApi } from './index';
import { config } from '../config';

interface CallbackProps {
  phone: string;
  comment?: string;
}

export const ordersApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    authorizedCallback: build.mutation<{ success: string }, CallbackProps & { promoBannerId?: string }>({
      query: ({ phone, comment, promoBannerId }) => ({
        url: config.ORDERS.CALLBACK,
        method: 'POST',
        body: {
          phone,
          comment,
          ...(promoBannerId ? { promoBannerId } : {}),
        },
      }),
    }),
    unauthorizedCallback: build.mutation<{ success: string }, CallbackProps>({
      query: ({ phone, comment }) => ({
        url: config.ORDERS.UNAUTHORIZED_CALLBACK,
        method: 'POST',
        body: {
          phone,
          comment,
        },
      }),
    }),
    feedback: build.mutation<{ success: string }, { comment: string }>({
      query: ({ comment }) => ({
        url: config.ORDERS.FEEDBACK,
        method: 'POST',
        body: {
          comment,
        },
      }),
    }),
  }),
});
